import { SimpleGrid } from "@chakra-ui/layout";
import {
  BalancoFinanceiroResponse,
  FiltroRelatorioBalancoFinanceiro,
} from "core/features/relatorios/typings";
import {
  AiOutlineRise,
  AiOutlineFall,
} from "react-icons/ai";
import { FaEquals } from "react-icons/fa";
import { formatMoney } from "infra/helpers/number";
import colors from "resources/theme/colors";
import Card1Horizontal from "ui/components/Cards/Card1Horizontal";

export default function DashboardRelatorioBalancoFinanceiro({
  data,
  isFetching = false,
  onChangeFiltro,
  filtro,
}: {
  data?: BalancoFinanceiroResponse;
  isFetching?: boolean;
  onChangeFiltro?: (filtro: Partial<FiltroRelatorioBalancoFinanceiro>) => any;
  filtro?: FiltroRelatorioBalancoFinanceiro;
}) {
  const onClickReceitas = () => {
    onChangeFiltro?.({
      operacao: filtro?.operacao === 1 ? undefined : 1,
    });
  };

  const onClickDespesas = () => {
    onChangeFiltro?.({
      operacao: filtro?.operacao === -1 ? undefined : -1,
    });
  };

  return (
    <SimpleGrid columns={{ sm: 1, md: 2, lg: 4 }} gap="16px" mb="32px">
      <Card1Horizontal
        icon={<AiOutlineRise color={colors.green500} size={24} />}
        color={colors.green500}
        bg={colors.green100}
        description={"Total de receitas"}
        title={formatMoney(data?.totalReceita ?? 0)}
        loading={isFetching}
        onClick={onClickReceitas}
        selected={filtro?.operacao === 1}
      />

      <Card1Horizontal
        icon={<AiOutlineFall color={colors.red500} size={24} />}
        color={colors.red500}
        bg={colors.red100}
        description={`Total de despesas`}
        title={formatMoney(data?.totalDespesa ?? 0)}
        loading={isFetching}
        onClick={onClickDespesas}
        selected={filtro?.operacao === -1}
      />

      <Card1Horizontal
        icon={<FaEquals color={colors.gray} size={24} />}
        color={colors.gray}
        bg={colors.gray50}
        description={`Resultado`}
        title={formatMoney(data?.saldoPeriodo ?? 0)}
        loading={isFetching}
      />
    </SimpleGrid>
  );
}
